export const sidebarTokens = {
  'sidebar-width': '320px',
  'sidebar-bg': 'var(--dp-color-background)',
  'sidebar-border-color': 'var(--dp-color-border)',
  'sidebar-border-width': '1px',
  'sidebar-padding': 'var(--dp-spacing-md)',
  'sidebar-item-height': '40px',
  'sidebar-item-padding-x': 'var(--dp-spacing-md)',
  'sidebar-item-hover-bg': 'var(--dp-color-surface-hover)',
  'sidebar-item-active-bg': 'var(--dp-color-primary-light)',
  'sidebar-item-active-text': 'var(--dp-color-primary)',
  'sidebar-item-border-radius': 'var(--dp-border-radius-md)',
  'sidebar-header-height': '56px',
  'sidebar-z-index': '200',
} as const;
